import React, { Component } from 'react';
import { connect } from 'dva';
import Banner from './Components/Banner';
import ListModule from './Components/ListModule';
import ImageModule from './Components/ImageModule';
import ColorModule from './Components/ColorModule';
import ColorModule30 from './Components/ColorModule30';
import ColorModule31 from './Components/ColorModule31';
import IconModule from './Components/IconModule';
import IconModule40 from './Components/IconModule40';
import IconModule41 from './Components/IconModule41';
import IconModule42 from './Components/IconModule42';
import IconListModule5 from './Components/IconListModule5';
import IconListModule51 from './Components/IconListModule51';
import ImageListModule52 from './Components/ImageListModule52';
import IconImageListModule6 from './Components/IconImageListModule6';
import IconImageListModule6Icon from './Components/IconImageListModule6/icon';
import styles from './index.less';

@connect(({ homePage }) => ({
  ...homePage,
}))
class PhonePreview extends Component {
  render() {
    const { phoneData } = this.props;
    const { templateName, bannerData, carouselModule, modulesData, picurl, stencilId } = phoneData;

    return (
      <div className={styles.root}>
        <div className="phone">
          <div className="phone-content">
            <div className="phone-title">{templateName}</div>
            <section
              className={`detail-content ${stencilId === 31 ? 'content31' : ''} ${
                stencilId === 42 || stencilId === 41 || stencilId === 40 ? 'content40' : ''
              }`}
            >
              {stencilId !== 30 && stencilId !== 41 && stencilId !== 42 && stencilId !== 6 && (
                <Banner carouselModule={carouselModule} bannerData={bannerData} />
              )}
              {(stencilId === 1 || stencilId === 10) && (
                <ListModule modules={modulesData} stencilId={stencilId} />
              )}
              {stencilId === 2 && <ImageModule modules={modulesData} />}
              {stencilId === 3 && <ColorModule modules={modulesData} />}
              {stencilId === 30 && <ColorModule30 modules={modulesData} />}
              {stencilId === 31 && <ColorModule31 modules={modulesData} picurl={picurl} />}
              {stencilId === 4 && <IconModule modules={modulesData} />}
              {stencilId === 40 && <IconModule40 modules={modulesData} />}
              {stencilId === 41 && <IconModule41 modules={modulesData} picurl={picurl} />}
              {stencilId === 42 && <IconModule42 modules={modulesData} picurl={picurl} />}
              {stencilId === 5 && <IconListModule5 modules={modulesData} />}
              {stencilId === 51 && <IconListModule51 modules={modulesData} />}
              {stencilId === 52 && <ImageListModule52 modules={modulesData} />}
              {stencilId === 6 && <IconImageListModule6Icon modules={modulesData} />}
              {(stencilId === 41 || stencilId === 42 || stencilId === 6) && (
                <Banner carouselModule={carouselModule} bannerData={bannerData} />
              )}
              {stencilId === 6 && <IconImageListModule6 modules={modulesData} />}
            </section>
          </div>
        </div>
        <div className="tips">点击预览后，可在此查看最终样式</div>
      </div>
    );
  }
}

export default PhonePreview;
